import { CardInfo, getCDNUrl, Counter, usePaymentOrder } from "@shared"
import { useMemo, useState } from "react"
import styles from "./DonateWithSlider.module.scss"
import { Button } from "../../Button"

const CONFIG = {
    TON: {
        step: 1,
        defaultValue: 1,
        sufix: 'ton',
    },
    XTR: {
        step: 10,
        defaultValue: 10,
        sufix: <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none" style={{ marginBottom: '4rem' }}>
            <path d="M8.00706 0.325212C7.79578 -0.108405 7.20422 -0.108404 6.99294 0.325213L5.07186 4.26788C4.98914 4.43764 4.83392 4.55575 4.65421 4.58569L0.480449 5.28093C0.0214155 5.3574 -0.161387 5.94666 0.167068 6.29111L2.90821 9.16578C3.05886 9.32377 3.27992 9.38077 3.48297 9.31274C4.31725 9.0332 6.47523 8.30914 6.87025 8.16674C7.16986 8.05873 7.38846 8.46711 7.14417 8.67847L3.28943 12.0136C3.07528 12.1989 2.93319 12.4598 2.88991 12.7472L2.65462 14.3096C2.5822 14.7905 3.06079 15.1547 3.47506 14.934L7.24188 12.9269C7.40407 12.8405 7.59593 12.8405 7.75812 12.9269L11.5249 14.934C11.9392 15.1547 12.4178 14.7905 12.3454 14.3096L11.6869 9.93729C11.6586 9.74902 11.7179 9.55791 11.8465 9.42306L14.8329 6.29111C15.1614 5.94666 14.9786 5.3574 14.5196 5.28093L10.3458 4.58569C10.1661 4.55575 10.0109 4.43764 9.92814 4.26788L8.00706 0.325212Z" fill="white" />
        </svg>
    }
}

export const DonateWithSlider = (props: { cur: "TON" | "XTR", onClose: () => void }) => {
    const { donateForTON, donateForXTR } = usePaymentOrder()
    const [quantity, setQuantity] = useState(CONFIG[props.cur].defaultValue)
    const handleQuantityChange = (quantity: number) => {
        setQuantity(Math.max(0, Math.min(quantity, 99999999)))
    }
    const cardInfo = useMemo(() => {
        return {
            url: props.cur === 'TON' ? getCDNUrl("/assets/donate/Ton.png") : getCDNUrl("/assets/donate/Stars.png"),
            effects: {},
            description: ''
        }
    }, [])

    return <CardInfo
        url={cardInfo.url}
        effects={cardInfo.effects}
        description={cardInfo.description}
        onClose={props.onClose}
    >
        <div className={styles.actions}>
            <Counter
                className={styles.counter}
                quantity={quantity}
                sufix={CONFIG[props.cur].sufix}
                step={CONFIG[props.cur].step}
                onQuantityChange={handleQuantityChange}
            />
            <Button
                icon="use"
                onClick={() => {
                    if (!quantity) return;
                    if (props.cur === 'TON') {
                        donateForTON(quantity)
                    } else {
                        donateForXTR(quantity)
                    }
                    props.onClose()
                }}
            >
                Donate
            </Button>
        </div>
    </CardInfo>
}